export enum RENTER_PATHS {
  HOME = 'renter',
  CERTIFICATION = 'certification/:certificationId',
  HOUSEHOLDS = 'households',
  HOUSEHOLD = 'households/:householdId',
  SIGNATURES = 'signatures',
  SIGNATURES_SIGN_DOC = 'signatures/sign/:fsrId',
  SIGNATURES_VIEW = 'signatures/view/:certId/doc/:docId',
  HISTORY = 'history',
  NOTIFICATIONS = 'notifications',
  SETTINGS = 'settings',
  ACCOUNT_HUB = 'account-hub',
  ACCOUNT_HUB_USER = ':userId',
  ACCOUNT_HUB_LOGIN_SECURITY = 'login-security',
  ACCOUNT_HUB_LOGIN_SECURITY_TFA = '2fa',
  ACCOUNT_HUB_LOGIN_SECURITY_TFA_SETUP = 'setup',
  ACCOUNT_HUB_LOGIN_SECURITY_TFA_MANAGE = 'manage',
  ACCOUNT_HUB_LOGIN_SECURITY_BACKUP_CODES = 'backup-codes',
  ACCOUNT_HUB_LOGIN_SECURITY_SESSIONS = 'sessions',
  ACCOUNT_HUB_CONTACT_INFO = 'contact-information',
  ACCOUNT_HUB_PERSONAL_INFO = 'personal-information',
  ACCOUNT_HUB_DATA_PRIVACY = 'privacy',
  ACCOUNT_HUB_PROPERTY_LIST = 'properties',
  // AIFileUploadV2 routes (AC-2.8)
  HUB = 'files',
  HUB_DETAIL = 'files/:fileId',
  // Cert-scoped: /renter/certification/:certificationId/files/:userId
  CERT_HUB = 'files/:userId',
  CERT_HUB_CLASSIFY = 'files/:userId/classify',
  CERT_HUB_REVIEW = 'files/:userId/review',
  CERT_HUB_DETAIL = 'files/:userId/:fileId',
  HUB_CLASSIFY = 'files/classify',
  HUB_REVIEW = 'files/review',
  HUB_GROUP_EDITOR = 'files/review/groups/:groupKey',
  // Interview (ENG-2265)
  INTERVIEW = 'interview/:surveyId',
  INTERVIEW_ON_BEHALF = 'interview/:surveyId/members/:memberId',
  // Survey explorer (read-only, survey-id-driven, no elevation gate)
  SURVEY = 'survey/:surveyId',
  SURVEY_SECTION = 'survey/:surveyId/sections/:sectionId',
  SURVEY_MEMBER = 'survey/:surveyId/members/:memberId',
  SURVEY_MEMBER_SECTION = 'survey/:surveyId/members/:memberId/sections/:sectionId',
  // Certification hub (cert-scoped landing for renters with progress, ENG-2968)
  CERT_HUB_PAGE = 'hub/:userId',
  // My Documents (ENG-2969)
  SURVEY_MY_DOCUMENTS = 'survey/:surveyId/my-documents',
  SURVEY_MEMBER_MY_DOCUMENTS = 'survey/:surveyId/members/:memberId/my-documents',
  SURVEY_MY_DOCUMENTS_ANSWER = 'survey/:surveyId/my-documents/answer',
  SURVEY_MEMBER_MY_DOCUMENTS_ANSWER = 'survey/:surveyId/members/:memberId/my-documents/answer',
  // Appointments — renter self-booking (ENG-3895)
  APPOINTMENTS = 'appointments',
  APPOINTMENTS_BOOK = 'appointments/book/:certificationId',
}

/** Self-booking flow for a certification. `rescheduleId` moves an existing
 * appointment instead of creating a new one. */
export function buildBookingPath(
  certificationId: number,
  rescheduleId?: number | null,
  categoryId?: number | null
): string {
  const params = new URLSearchParams();
  if (rescheduleId) {
    params.set('reschedule', String(rescheduleId));
  }
  if (categoryId) {
    params.set('category', String(categoryId));
  }
  const query = params.toString();
  return `/${RENTER_PATHS.HOME}/appointments/book/${certificationId}${
    query ? `?${query}` : ''
  }`;
}

export function buildCertificationHubPath(
  certificationId: number,
  userId: number
): string {
  return `/${RENTER_PATHS.HOME}/certification/${certificationId}/hub/${userId}`;
}

/** My Documents URL for a survey, optionally acting on behalf of a member. */
export function buildMyDocumentsPath(
  surveyId: number,
  memberUserId?: number | null
): string {
  if (memberUserId != null) {
    return `/${RENTER_PATHS.HOME}/survey/${surveyId}/members/${memberUserId}/my-documents`;
  }
  return `/${RENTER_PATHS.HOME}/survey/${surveyId}/my-documents`;
}

/** Interview URL for a survey, optionally acting on behalf of a member. */
export function buildInterviewPath(
  surveyId: number,
  memberUserId?: number | null
): string {
  if (memberUserId != null) {
    return `/${RENTER_PATHS.HOME}/interview/${surveyId}/members/${memberUserId}`;
  }
  return `/${RENTER_PATHS.HOME}/interview/${surveyId}`;
}
